import PageHeading from '../../shared/components/UIElements/PageHeading';
import EmptyState from '../../shared/components/UIElements/EmptyState';
// PharmacyCRM.js
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../shared/Context/auth-context';
import './PharmacyAlert.css';
import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button';
import { BACKEND_URL } from '../../shared/util/backend-url';

const PharmacyCRM = () => {
  const auth = useContext(AuthContext);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const response = await fetch(
          `${BACKEND_URL}/api/pharmacyalerts/${auth.pharmacyId}`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`
            }
          }
        );
        const data = await response.json();
        setAlerts(data.alerts);
      } catch (err) {
        console.error('Error fetching alerts:', err);
      }
    };

    fetchAlerts();
  }, [auth.pharmacyId, auth.token]);

  const handleStatusChange = async (id, status) => {
    try {
      await fetch(`${BACKEND_URL}/api/pharmacyalerts/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`
        },
        body: JSON.stringify({ status })
      });

      setAlerts((prev) => prev.map((a) => (a._id === id ? { ...a, status } : a)));
    } catch (err) {
      console.error('Update failed:', err);
    }
  };

  return (
    <div className="pharmacy-crm">
      <PageHeading
        eyebrow="PATIENT FOLLOW-UPS"
        title="Medication refill alerts"
        description="Track upcoming refills and keep follow-ups moving."
      />
      <Card className="pharmacy-dashboard__card">
        {alerts.length === 0 ? (
          <EmptyState icon="bell" title="No refill alerts">
            Medication refill follow-ups will appear here.
          </EmptyState>
        ) : (
          alerts.map((alert) => (
            <div key={alert._id} className={`alert-card ${alert.status}`}>
              <h4>
                {alert.patient.name} - {alert.medicationName}
              </h4>
              <p>Refill Date: {new Date(alert.refillDate).toLocaleDateString()}</p>
              <p>Status: {alert.status}</p>
              <p>
                <strong>Prescribed By:</strong> {alert.doctor?.name || 'Unknown'}
              </p>
              <div className="alert-actions">
                <Button onClick={() => handleStatusChange(alert._id, 'checked')}>Check</Button>
                <Button onClick={() => handleStatusChange(alert._id, 'dispatched')}>
                  Dispatch
                </Button>
              </div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
};

export default PharmacyCRM;
